export default __webpack_public_path__ + "static/media/search.81c6609a.svg";